


const DishCartAPI = [
    {
        id: 0,
        path: './Images/dosaMasala.jpg',
        dish_name: 'Masala Dosa : ',
        price: '25'
    },
    {
        id: 1,
        path: './Images/juice.jpeg',
        dish_name: 'Juice : ',
        price: '10'
    },
    {
        id: 2,
        path: './Images/veggie.jpg',
        dish_name: 'Aaloo Gunda : ',
        price: '20'
    },
    {
        id : 3,
        path: './Images/dahiSamosa_logo.jpeg',
        dish_name: 'Dahi samosa : ',
        price: '30'
    },
        {
            id: 4,
            path: './Images/samosa3.jpg',
            dish_name: 'Samosa : ',
            price: '20'
        },
    {
        id: 5,
        path: './Images/aaloogunda2.jpg',
        dish_name: 'Masala Dosa : ',
        price: '25'
    },
    {
        id: 6,
        path: './Images/tea.jpeg',
        dish_name: 'Tea : ',
        price: '10'
    },
    {
        id : 7,
        path: './Images/samosa3.jpg',
        dish_name: 'Samosa : ',
        price: '20'
    },
    {
        id: 8,
        path: './Images/Dosa.jpg',
        dish_name: 'Dosa : ',
        price: '20'
    },
    {
        id : 9,
        path: './Images/Pizza.jpg',
        dish_name: 'Pizza : ',
        price: '110'
    },
]

export default DishCartAPI